/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { DHSurveyJobDefinition } from '../models/DHSurveyJobDefinition';
import type { GetParticipationSurveyJobCompanyJobsRequest } from '../models/GetParticipationSurveyJobCompanyJobsRequest';
import type { GetParticipationSurveyJobCompanyJobsResponse } from '../models/GetParticipationSurveyJobCompanyJobsResponse';
import type { Participation } from '../models/Participation';
import type { ParticipationJobMappingsRequest } from '../models/ParticipationJobMappingsRequest';
import type { ParticipationTab } from '../models/ParticipationTab';
import type { SalaryRangeTypeOfPay } from '../models/SalaryRangeTypeOfPay';
import type { SaveParticipationSurveyJobCompanyJobMappingsRequest } from '../models/SaveParticipationSurveyJobCompanyJobMappingsRequest';
import type { SaveParticipationSurveyJobCompanyJobMappingsResponse } from '../models/SaveParticipationSurveyJobCompanyJobMappingsResponse';
import type { SurveyJobCompanyJobMapping } from '../models/SurveyJobCompanyJobMapping';
import type { SurveyJobCompanyJobMappingDuplicate } from '../models/SurveyJobCompanyJobMappingDuplicate';
import type { SurveyJobCompanyJobMappingStatus } from '../models/SurveyJobCompanyJobMappingStatus';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class ParticipationService {

    /**
     * List Participation Templates
     * @returns any Success
     * @throws ApiError
     */
    public static listParticipationTemplates({
        vendor,
        profile,
        search,
        offset,
        limit,
        order,
    }: {
        vendor?: string,
        profile?: string,
        search?: string,
        offset?: number,
        limit?: number,
        order?: Record<string, any>,
    }): CancelablePromise<{
        rows: Array<Participation>;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/participation',
            query: {
                'vendor': vendor,
                'profile': profile,
                'search': search,
                'offset': offset,
                'limit': limit,
                'order': order,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Sync Participation Templates (add, remove, update plans in a single transaction)
     * @returns any Success
     * @throws ApiError
     */
    public static syncParticipations({
        requestBody,
    }: {
        requestBody?: {
            additions?: Array<{
                participationId: string;
                planIds?: Array<number>;
            }>;
            removals?: Array<string>;
            planUpdates?: Array<{
                participationId: string;
                planIds: Array<number>;
            }>;
        },
    }): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/participation/sync',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Get Participation Template
     * @returns Participation Success
     * @throws ApiError
     */
    public static getParticipationTemplate({
        participationId,
    }: {
        participationId: string,
    }): CancelablePromise<Participation> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/participation/{participationId}',
            path: {
                'participationId': participationId,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Get Participation Field Mappings
     * @returns any Success - Returns all compensation tabs with merged field mappings
     * @throws ApiError
     */
    public static getParticipationFieldMappings({
        participationId,
    }: {
        participationId: string,
    }): CancelablePromise<{
        tabs?: Array<ParticipationTab>;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/participation/{participationId}/fieldMappings',
            path: {
                'participationId': participationId,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Update Participation
     * @returns any Success
     * @throws ApiError
     */
    public static updateParticipation({
        participationId,
        requestBody,
    }: {
        participationId: string,
        requestBody: {
            tabs: Array<ParticipationTab>;
        },
    }): CancelablePromise<{
        success?: boolean;
    }> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/participation/{participationId}/fieldMappings',
            path: {
                'participationId': participationId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Delete Participation Field Mappings
     * @returns void
     * @throws ApiError
     */
    public static deleteCustomParticipationFieldMappings({
        participationId,
    }: {
        participationId: string,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/participation/{participationId}/fieldMappings',
            path: {
                'participationId': participationId,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Get Participation Template Data
     * @returns any Success
     * @throws ApiError
     */
    public static getParticipationData({
        participationId,
        requestBody,
    }: {
        participationId: string,
        requestBody: {
            plan: number;
            mappingType: Array<SurveyJobCompanyJobMappingStatus>;
            tabName: string;
            module?: Array<string>;
            country?: Array<string>;
            state?: Array<string>;
            customField?: Array<string>;
            typeOfPay?: SalaryRangeTypeOfPay;
            sort?: Record<string, any>;
            limit?: number;
            offset?: number;
            includeSlottedMappings?: boolean;
        },
    }): CancelablePromise<{
        rows?: any[];
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/participation/{participationId}/data',
            path: {
                'participationId': participationId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Export Participation Template Data
     * @returns any Success
     * @throws ApiError
     */
    public static exportParticipationData({
        participationId,
        requestBody,
    }: {
        participationId: string,
        requestBody?: {
            plan: number;
            mappingType: Array<string>;
            module?: Array<string>;
            typeOfPay?: SalaryRangeTypeOfPay;
            includeSlottedMappings?: boolean;
        },
    }): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/participation/{participationId}/export',
            path: {
                'participationId': participationId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Get Participation Job Mappings
     * @returns any Success
     * @throws ApiError
     */
    public static getParticipationJobMappings({
        participationId,
        requestBody,
    }: {
        participationId: string,
        requestBody: ParticipationJobMappingsRequest,
    }): CancelablePromise<{
        SurveyJobs?: Array<DHSurveyJobDefinition>;
        SurveyJobCompanyJobMappings?: Array<SurveyJobCompanyJobMapping>;
        SurveyJobCompanyJobMappingsDuplicates?: Array<SurveyJobCompanyJobMappingDuplicate>;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/participation/{participationId}/jobMappings',
            path: {
                'participationId': participationId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Get Company Jobs for Survey Job Mapping
     * @returns GetParticipationSurveyJobCompanyJobsResponse Success
     * @throws ApiError
     */
    public static getParticipationSurveyJobCompanyJobs({
        participationId,
        requestBody,
    }: {
        participationId: string,
        requestBody: GetParticipationSurveyJobCompanyJobsRequest,
    }): CancelablePromise<GetParticipationSurveyJobCompanyJobsResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/participation/{participationId}/jobMappings/search/companyJobs',
            path: {
                'participationId': participationId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Save Survey Job to Company Job Mappings
     * @returns SaveParticipationSurveyJobCompanyJobMappingsResponse Success
     * @throws ApiError
     */
    public static saveParticipationSurveyJobCompanyJobMappings({
        participationId,
        requestBody,
    }: {
        participationId: string,
        requestBody: SaveParticipationSurveyJobCompanyJobMappingsRequest,
    }): CancelablePromise<SaveParticipationSurveyJobCompanyJobMappingsResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/participation/{participationId}/jobMappings/surveyJob',
            path: {
                'participationId': participationId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Get Participation Job Mappings Count
     * @returns any Success
     * @throws ApiError
     */
    public static getParticipationJobMappingsCount({
        participationId,
        requestBody,
    }: {
        participationId: string,
        requestBody?: Record<string, any>,
    }): CancelablePromise<{
        MappedJobsCount?: number;
        TotalJobsCount?: number;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/participation/{participationId}/jobMappingsCount',
            path: {
                'participationId': participationId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

}
